@if (media.mediaType === MediaType.Video) {
	<div
		class="mediaCard"
		[class.active]="media.id === mediaPlayer?.info?.currentMedia?.mediaId && mediaPlayer?.info?.currentMedia?.isPlaying"
		(click)="mediaClicked()"
	>
		<div class="mediaHeader">
			<mat-icon class="mediaIcon"> videocam </mat-icon>
			<video [src]="simUtilityService.getMediaPath(media)" style="width: 100%; position: absolute" preload="metadata"></video>
			<div class="controlsContainer">
				<button
					mat-mini-fab
					color="accent"
					class="mediaPlayButton"
					[disabled]="mediaPlayer?.webSocket?.activityState === ActivityState.Inactive"
				>
					<sim-animated-material-icon
						[trigger]="media.id === mediaPlayer?.info?.currentMedia?.mediaId && mediaPlayer?.info?.currentMedia?.isPlaying"
						[endIcon]="{
							fontSet: 'fad',
							fontIcon: 'fa-stop',
							themeColor: 'accent',
						}"
						[startIcon]="{
							fontSet: 'fad',
							fontIcon: 'fa-play',
							themeColor: 'white',
						}"
					/>
				</button>
			</div>
			@if (media.id === mediaPlayer?.info?.currentMedia?.mediaId && mediaPlayer?.info?.currentMedia?.isPlaying) {
				<div class="progressBar">
					<mat-progress-bar
						color="accent"
						mode="determinate"
						[value]="progressFromDisplayedMedia(mediaPlayer?.info?.currentMedia) * 100"
					/>
				</div>
			}
		</div>
		<div class="mediaText">
			<div class="title">{{ media.name }}</div>
			<div class="description">{{ media.fileName }}</div>
		</div>
	</div>
}
